import React, { createContext, useState, useEffect, useContext } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Siempre usar modo claro
  const [darkMode] = useState(false);

  useEffect(() => {
    // Guardar siempre como true en localStorage
    localStorage.setItem('darkMode', false);
    
    // Aplicar clase dark-mode al body
    document.body.classList.remove('dark-mode');
  }, []);

  // Función de toggle que no hace nada (mantiene compatibilidad)
  const toggleDarkMode = () => {
    // No hace nada, siempre seguirá en modo claro
  };

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook to use the theme context
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export default ThemeContext; 